import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { firebase_app } from "../data/config";
import { authHeader, handleResponse } from "../services/fack.backend";
import { useDispatch, useSelector } from "react-redux";

const PrivateRoute = () => {
  const isAuthenticated = useSelector(
    state => state?.authReducer?.isAuthenticated || false
  );

  return isAuthenticated
    ? <Outlet />
    : <Navigate to={`/login`} />;
};

export default PrivateRoute;
